import React, { useContext } from 'react';
import { UseReportResponse } from '../Forms/hooks/useReport/useReport';
import { ReportContext } from '../context/ReportProvider';

interface QSightDataTablePaginationProps {
    reportState: UseReportResponse<unknown>
    currentPage: number;
    totalPages: number;
    onPageChange?: (page: number) => void;
}

const QSightDataTablePagination: React.FC<QSightDataTablePaginationProps> = ({
    reportState,
    currentPage,
    totalPages,
    onPageChange = reportState.setPage,
}) => {
    const reportContext = useContext(ReportContext);
    const derivedCurrentPage = reportState.page ?? currentPage;

    // Handle going to the previous page
    const handlePrevious = () => {
        if (derivedCurrentPage > 1) {
            reportState.goToPreviousPage();
            onPageChange(derivedCurrentPage - 1);
            reportContext?.setReportCurrentPageNumber((prev: number) => prev - 1);
        }
    };

    // Handle going to the next page
    const handleNext = () => {
        if (reportState.nextPageToken) {
            reportState.goToNextPage();
            onPageChange(derivedCurrentPage + 1);
            reportContext?.setReportCurrentPageNumber((prev: number) => prev + 1);
        }
    };

    const summaryText = (() => {
        const pageSize = reportContext?.reportPageSize ?? (reportState?.data?.length ?? 0);
        const totalCountNum =
            reportContext?.reportTotalCount ?? parseInt(reportState?.totalCount ?? '0', 10);
        const current = reportContext?.reportCurrentPageNumber ?? derivedCurrentPage;
        if (!pageSize || totalCountNum === 0) return '0 of 0 records';
        const start = (current - 1) * pageSize + 1;
        const end = Math.min(current * pageSize, totalCountNum);
        return `${start}-${end} of ${totalCountNum} records`;
    })();

    return (
        <>
            {summaryText}
            <div className="pagination-container">
                <button
                    onClick={handlePrevious}
                    disabled={derivedCurrentPage <= 1}
                    className="pagination-button"
                >
                    Previous
                </button>
                <button
                    onClick={handleNext}
                    disabled={!reportState.nextPageToken}
                    className="pagination-button"
                >
                    Next
                </button>
            </div>
            <div>
                Page {derivedCurrentPage}
            </div>
        </>
    );
};

export default QSightDataTablePagination;